<template>
  <div v-if="$template" class="relative campaign-container">
    <div class="!bg-white lg:flex">
      <CartResume @openNotification="openNotification" @openModal="openModal" />

      <!-- Formulaire pour les winners wheel -->
      <FormResumeWinner v-if="isWheelWinner" @openModal="openModal" @openNotification="openNotification" />
      <!-- Formulaire classique -->
      <FormResume v-else @openModal="openModal" @openNotification="openNotification" />
    </div>

    <div>
      <div class="lg:hidden flex justify-center bg-white items-center p-2">
        <img src="@/assets/img/rea1.png" alt="" class="w-[35%]">
        <img src="@/assets/img/rea2.png" alt="" class="w-[35%]">
      </div>
      <div class="lg:hidden flex justify-center bg-white items-center p-2">
        <img src="@/assets/img/rea3.png" alt="" class="w-[35%]">
        <img src="@/assets/img/rea4.png" alt="" class="w-[35%] cursor-pointer" @click="
          openModal(
            'Contact',
            $template.contact,
            $template.contact_picture
          )
          ">
      </div>
    </div>
  </div>

</template>

<script>
import CartResume from '../common/components/CartResume.vue'
import FormResume from '../common/components/FormResume.vue'
import FormResumeWinner from '../common/components/FormResumeWinner.vue'

export default {
  components: {
    CartResume,
    FormResume,
    FormResumeWinner
  },
  emits: ['openModal', 'openNotification'],
  computed: {
    isWheelWinner() {
      return this.$store.isWheelWinner && this.$store.wheelWinner?.token
    }
  },
  methods: {
    openNotification(message, isError) {
      this.$emit(
        'openNotification',
        message,
        isError
      )
    },
    openModal(title, message, img) {
      this.$emit('openModal', title, message, img)
    }
  },
  beforeMount() {
    if (this.$template) {
      document.body.style.backgroundColor =
        this.$template.page_background_color
    }
    window.scrollTo(0, 0);
  },
}
</script>

<style scoped>
.div-form {
  @apply lg:flex w-full mt-3;
}

.input-form {
  @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}
</style>
